// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Job Configuration page – uses admin common.css */
.job-config-page .admin-page-container {
  padding: 32px;
}

/* Shared interval (one per section, below title — not per table row) */
.job-config-section-interval {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding: 14px 16px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  max-width: 720px;
}

.job-config-section-interval-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
  min-width: 88px;
}

.job-config-section-interval-input {
  flex: 1 1;
  min-width: 200px;
  max-width: 360px;
}

/* Time Period header centred over Start/End columns */
.job-config-time-period-header {
  text-align: center;
}

/* Period: one header "Time Period" with two sub-columns */
.job-config-period-subhead th {
  font-weight: 500;
  font-size: 0.875em;
  color: #64748b;
  border-top: none;
  padding-top: 0;
}

.job-config-period-subhead-cell {
  text-align: center;
}

.job-config-period-cell {
  text-align: center;
}

/* Application configuration block (aligned with Job Configuration layout) */
.job-config-app-section {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 1px solid #e2e8f0;
}

.job-config-app-status-stopped {
  color: #dc2626;
  font-weight: 700;
  text-transform: uppercase;
}

/* Ant Design modals & forms — SaaS polish */
.job-config-modal .ant-modal-header {
  margin-bottom: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.job-config-modal .ant-modal-title {
  margin: 0;
}

.job-config-modal-title {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

.job-config-modal-heading {
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.job-config-modal-subtitle {
  display: block;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.45;
  max-width: 100%;
}

.job-config-form.ant-form-vertical .ant-form-item {
  margin-bottom: 20px;
}

.job-config-form.ant-form-vertical .ant-form-item-label > label {
  font-weight: 600;
  color: #334155;
}

.job-config-form .ant-form-item-extra {
  font-size: 12px;
  color: #64748b;
  margin-top: 6px;
}

.job-config-form-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
}

.job-config-form-footer .ant-btn-primary {
  min-width: 120px;
  font-weight: 600;
}

.job-config-select-dropdown .ant-select-item-option-selected {
  font-weight: 600;
}

/* ===== Dark theme overrides (light mode untouched; antd themed via provider) ===== */
[data-theme="dark"] .job-config-section-interval {
  background: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .job-config-section-interval-label,
[data-theme="dark"] .job-config-form.ant-form-vertical .ant-form-item-label > label {
  color: var(--text);
}
[data-theme="dark"] .job-config-period-subhead th,
[data-theme="dark"] .job-config-form .ant-form-item-extra {
  color: var(--text-muted);
}
[data-theme="dark"] .job-config-app-section {
  border-top-color: var(--border);
}
[data-theme="dark"] .job-config-modal .ant-modal-header,
[data-theme="dark"] .job-config-form-footer {
  border-color: var(--border);
}
[data-theme="dark"] .job-config-modal-heading {
  color: var(--text-strong);
}

/* Mobile — desktop layout above unchanged */
@media (max-width: 768px) {
  .job-config-page .admin-page-container {
    padding: 12px;
  }

  .job-config-section-interval {
    flex-direction: column;
    align-items: stretch;
    max-width: none;
  }

  .job-config-section-interval-input {
    min-width: 0;
    max-width: none;
    width: 100%;
  }

  .job-config-app-section {
    margin-top: 32px;
    padding-top: 24px;
  }

  .job-config-form-footer {
    flex-direction: column-reverse;
    gap: 8px;
  }

  .job-config-form-footer .ant-btn,
  .job-config-form-footer .ant-btn-primary {
    width: 100%;
    min-width: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/batch-monitor/JobConfiguration/index.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;AACpB;;AAEA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sFAAsF;AACtF;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,+BAA+B;AACjC;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Job Configuration page – uses admin common.css */\n.job-config-page .admin-page-container {\n  padding: 32px;\n}\n\n/* Shared interval (one per section, below title — not per table row) */\n.job-config-section-interval {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding: 14px 16px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  max-width: 720px;\n}\n\n.job-config-section-interval-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #334155;\n  min-width: 88px;\n}\n\n.job-config-section-interval-input {\n  flex: 1;\n  min-width: 200px;\n  max-width: 360px;\n}\n\n/* Time Period header centred over Start/End columns */\n.job-config-time-period-header {\n  text-align: center;\n}\n\n/* Period: one header \"Time Period\" with two sub-columns */\n.job-config-period-subhead th {\n  font-weight: 500;\n  font-size: 0.875em;\n  color: #64748b;\n  border-top: none;\n  padding-top: 0;\n}\n\n.job-config-period-subhead-cell {\n  text-align: center;\n}\n\n.job-config-period-cell {\n  text-align: center;\n}\n\n/* Application configuration block (aligned with Job Configuration layout) */\n.job-config-app-section {\n  margin-top: 48px;\n  padding-top: 32px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.job-config-app-status-stopped {\n  color: #dc2626;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n/* Ant Design modals & forms — SaaS polish */\n.job-config-modal .ant-modal-header {\n  margin-bottom: 8px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.job-config-modal .ant-modal-title {\n  margin: 0;\n}\n\n.job-config-modal-title {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-start;\n}\n\n.job-config-modal-heading {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.job-config-modal-subtitle {\n  display: block;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.45;\n  max-width: 100%;\n}\n\n.job-config-form.ant-form-vertical .ant-form-item {\n  margin-bottom: 20px;\n}\n\n.job-config-form.ant-form-vertical .ant-form-item-label > label {\n  font-weight: 600;\n  color: #334155;\n}\n\n.job-config-form .ant-form-item-extra {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 6px;\n}\n\n.job-config-form-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 8px;\n  padding-top: 20px;\n  border-top: 1px solid #f1f5f9;\n}\n\n.job-config-form-footer .ant-btn-primary {\n  min-width: 120px;\n  font-weight: 600;\n}\n\n.job-config-select-dropdown .ant-select-item-option-selected {\n  font-weight: 600;\n}\n\n/* ===== Dark theme overrides (light mode untouched; antd themed via provider) ===== */\n[data-theme=\"dark\"] .job-config-section-interval {\n  background: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .job-config-section-interval-label,\n[data-theme=\"dark\"] .job-config-form.ant-form-vertical .ant-form-item-label > label {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .job-config-period-subhead th,\n[data-theme=\"dark\"] .job-config-form .ant-form-item-extra {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .job-config-app-section {\n  border-top-color: var(--border);\n}\n[data-theme=\"dark\"] .job-config-modal .ant-modal-header,\n[data-theme=\"dark\"] .job-config-form-footer {\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .job-config-modal-heading {\n  color: var(--text-strong);\n}\n\n/* Mobile — desktop layout above unchanged */\n@media (max-width: 768px) {\n  .job-config-page .admin-page-container {\n    padding: 12px;\n  }\n\n  .job-config-section-interval {\n    flex-direction: column;\n    align-items: stretch;\n    max-width: none;\n  }\n\n  .job-config-section-interval-input {\n    min-width: 0;\n    max-width: none;\n    width: 100%;\n  }\n\n  .job-config-app-section {\n    margin-top: 32px;\n    padding-top: 24px;\n  }\n\n  .job-config-form-footer {\n    flex-direction: column-reverse;\n    gap: 8px;\n  }\n\n  .job-config-form-footer .ant-btn,\n  .job-config-form-footer .ant-btn-primary {\n    width: 100%;\n    min-width: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
